import { useState, useEffect, useRef } from 'react'
import Image from 'next/image'
import { Number, Icon } from '.'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { RadioGroup, Transition } from '@headlessui/react'

const restaurantDirectory = [
    {
      name: 'McDonalds',
      className:"top-[36%] left-[56.5%] lg:left-[57.5%]"
    },
    {
      name: 'KFC',
      className:"top-[38.25%] left-[56%] lg:left-[57%]"
    },
    {
      name: 'A&W',
      className:"top-[46.75%] left-[59%] lg:left-[60%]"
    },
    {
      name:'Yesterday\'s Restaurant',
      className:"top-[31.5%] left-[56%] lg:left-[57%]"
    },
    {
      name:'Tim Hortons',
      className:"top-[48.5%] left-[86%] lg:left-[87%]"
    },
    {
      name:'The Brew Company',
      className:"left-[22.5%] lg:left-[23.5%] top-[19.75%]"
    },
    {
      name:'Ye Olde Chip Truck',
      className:"left-[15.5%] lg:left-[16.5%] top-[16.75%]"
    },
    {
      name:'Yummy Yummy',
      className:"left-[17.75%] lg:left-[18.75%] top-[9.25%]"
    },
    {
      name:'Hings',
      className:"left-[16.5%] lg:left-[18%] top-[11.5%] lg:top-[11%]"
    },
    {
      name:'Ho Ho Chinese Food',
      className:"left-[13.75%] lg:left-[15.25%] top-[13%]"
    },
    {
      name:'Kurry',
      className:"left-[13.25%] lg:left-[14.5%] top-[14.5%]"
    },
    {
      name:'Sushi 251',
      className:"left-[12%] lg:left-[13%] top-[18%] lg:top-[17%]"
    },
    {
      name:'Plaza',
      className:"left-[10%] lg:left-[11.5%] top-[12.25%]"
    },
    {
      name:'Cottage Time Public House',
      className:"left-[7.5%] lg:left-[8.5%] top-[10.5%]"
    },
    {
      name:'The Hungry Pug',
      className:"left-[9.25%] lg:left-[11%] top-[14.25%]"
    },
    {
      name:'Bob\'s Burger',
      className:"left-[8%] lg:left-[9%] top-[12.5%]"
    },
    {
      name:'Quesada Burritos & Tacos',
      className:"left-[7%] lg:left-[8%] top-[15%]"
    },
    {
      name:'Boston Pizza',
      className:"left-[7.5%] lg:left-[8.5%] top-[18%]"
    },
    {
      name:'The Boathouse',
      className:"left-[8.5%] left-[9.5%] top-[25%]"
    },
]
const indulgesDirectory = [
    {
      name: 'Lake of the Woods Cannabis',
      className:"top-[31%] left-[53%] lg:left-[55%]"
    },
    {
      name:'Thirsty\'s Lounge',
      className:"top-[31.5%] left-[56%] lg:left-[57%]"
    },
    {
      name: 'VapeMate',
      className:"left-[36%] lg:left-[37%] top-[10%]"
    },
    {
      name: 'The Beer Store',
      className:"left-[35%] lg:left-[36%] top-[7.5%]"
    },
    {
      name: 'LCBO',
      className:"left-[38.5%] lg:left-[39.5%] top-[7%]"
    },
    {
      name: 'T Cannibis',
      className:"left-[24%] lg:left-[25%] top-[19.75%]"
    },
    {
      name: 'The Brew Company',
      className:"left-[22.5%] lg:left-[23.5%] top-[19.75%]"
    },
    {
      name:'The Brew Company Beer Sales',
      className:"left-[23.25%] lg:left-[24.25%] top-[18.5%]"
    },
    {
      name:'Shooters',
      className:"left-[13.75%] lg:left-[15.25%] top-[13%]"
    },
    {
      name:'The Eagle\'s Nest',
      className:"left-[13.75%] lg:left-[14.75%] top-[13.75%]"
    },
    {
      name:'Bob\'s Burger Bar',
      className:"left-[8%] lg:left-[9%] top-[12.5%]"
    },
    {
      name:'The Vault Public House',
      className:"left-[7.75%] lg:left-[8.75%] top-[13.5%]"
    },
    {
      name:'Boston Pizza',
      className:"left-[7.5%] lg:left-[8.5%] top-[18%]"
    },
  ]
  const petsDirectory = [
    {
        name:'City of Kenora Dog Park',
        className:"top-[56%] left-[61%] lg:left-[62%]"
    },
    {
        name:'Chow Time Pet Supply',
        walking:0,
        driving:1,
        className:"top-[34%] left-[53%] lg:left-[55%]"
    },
    {
        name:'Kenora Veterinary Clinic',
        walking:0,
        driving:0,
        className:"left-[11.5%] lg:left-[12.5%] top-[23%]"
    },
    {
        name:'Pet Valu',
        walking:0,
        driving:0,
        className:"left-[22%] lg:left-[23%] top-[8.5%]"
    }
  ]
  const shoppingDirectory = [
    {
      name: 'Home Hardware',
      className:"top-[49%] left-[65%] lg:left-[66%]"
    },
    {
      name: 'Canadian Tire',
      className:"top-[53%] left-[75%] lg:left-[76%]"
    },
    {
        name: 'Walmart',
        className:"top-[61%] left-[69%] lg:left-[70%]"
      },
      {
        name: 'No Frills',
        className:"left-[33%] lg:left-[34%] top-[9%]"
      },
      {
        name: 'Mark\'s Work Warehouse',
        walking: 4,
        driving: 1,
        className:"left-[31.5%] lg:left-[32.5%] top-[9.5%]"
      },
      {
        name: 'Dollarama',
        walking: 4,
        driving: 1,
        className:"left-[30%] lg:left-[31%] top-[9.75%]"
      },
      {
        name: 'Warehouse One',
        walking: 4,
        driving: 1,
        className:"left-[15.5%] lg:left-[16.5%] top-[18.5%]"
      },
      {
        name: 'The Real Canadian Wholesale Club',
        walking: 4,
        driving: 1,
        className:"left-[71%] lg:left-[72%] top-[4.5%]"
      },
      {
        name: 'Safeway',
        walking: 4,
        driving: 1,
        className:"left-[20.5%] lg:left-[21.5%] top-[32%]"
      },
  ]
  const vehicleDirectory = [
    {
      name:'Dingwall Ford',
      walking:0,
      driving:0,
      className:"top-[40.5%] left-[56.5%] lg:left-[57.5%]"
    },
    {
        name:'Auto Parts Central',
        walking:0,
        driving:0,
        className:"top-[46.5%] left-[52%] lg:left-[53%]"
    },
    {
      name: 'Enterprise Rent-A-Car',
      walking: 4,
      driving: 1,
      className:"left-[74.5%] lg:left-[75.5%] top-[2.5%]"
    },
    {
      name: 'Bell\'s Corner Car Wash',
      walking: 4,
      driving: 1,
      className:"left-[75.5%] lg:left-[76.5%] top-[2.5%]"
    },
    {
      name: 'Crystal Clean Car Wash',
      walking: 4,
      driving: 1,
      className:"left-[78%] lg:left-[79%] top-[-1%]"
    },
    {
      name: 'Husky Car Wash',
      walking: 4,
      driving: 1,
      className:"top-[51%] left-[87%] lg:left-[88%]"
    },
    {
      name: 'Canadian Tire Auto Repair',
      walking: 5,
      driving: 1,
      className:"top-[51%] left-[75%] lg:left-[73.5%]"
    },
    {
      name: 'Scotty\'s Auto Service',
      walking: 4,
      driving: 1,
      className:"left-[20%] lg:left-[21%] top-[20.5%]"
    },
  ]
  const fishingDirectory = [
    {
      name: 'Sunset Baits',
      walking: 4,
      driving: 1,
      className:"top-[51%] left-[89.5%] lg:left-[90.5%]"
    },
    {
      name:'K-Sports Marina',
      walking:0,
      driving:0,
      className:"top-[28%] left-[70%]"
    },
    {
        name:'Halley\'s Camp Fly In Location',
        walking:0,
        driving:0,
        className:"left-[3.5%] lg:left-[4.5%] top-[11.5%]"
    },
    {
      name:'Musky Point Marina',
      walking:0,
      driving:0,
      className:"left-[0%] lg:left-[0%] top-[21%]"
    },
    {
        name:'Lake of the Woods Boat Launch',
        walking:0,
        driving:0,
        className:"left-[21.5%] lg:left-[22.5%] top-[35%]"
    }
  ]
const coffeeDirectory = [
  {
    name: 'McCafe',
    walking: 1,
    driving: 0,
    className:"top-[36%] left-[56.5%] lg:left-[57.5%]"
  },
  {
    name: 'A&W Brew Bar',
    walking: 1,
    driving: 1,
    className:"top-[46.75%] left-[59%] lg:left-[60%]"
  },
  {
    name:'Tim Hortons',
    className:"top-[48.5%] left-[86%] lg:left-[87%]"
  },
  {
    name: 'Starbucks (in Safeway)',
    walking: 4,
    driving: 1,
    className:"left-[20.5%] lg:left-[21.5%] top-[32%]"
  },
  {
    name:'Iron & Clay Coffee Shop',
    walking:0,
    driving:0,
    className:"left-[11%] lg:left-[12%] top-[14.75%]"
  },
  {
    name:'HoJoe Coffee & Eatery',
    walking:18,
    driving:3,
    className:"left-[10.5%] lg:left-[12%] top-[10.25%]"
  },
]
const attractionsDirectory = [
  {
    name:'MS Kenora',
    className:"left-[7.5%] lg:left-[5%] top-[9%]"
  },
  {
    name:'The Muse',
    walking:18,
    driving:3,
    className:"left-[5%] lg:left-[6%] top-[20%]"
  },
  {
    name:'Salisbury Cruises Ltd',
    walking:18,
    driving:3,
    className:"left-[0%] lg:left-[.5%] top-[18.5%]"
  },
  {
    name:'Whitecap Pavilion',
    walking:0,
    driving:0,
    className:"left-[8%] lg:left-[9%] top-[4%]"
  },
  {
    name:'Houseboat Adventures',
    walking:18,
    driving:3,
    className:"left-[8.5%] left-[9.5%] top-[25%]"
  },
]
const recreationDirectory = [
    {
      name:'City of Kenora Dog Park',
      walking: 7,
      driving: 1,
      className:"top-[56%] left-[61%] lg:left-[62%]"
    },
    {
      name:'Anicinabe Park',
      walking: 7,
      driving: 1,
      className:"top-[83%] left-[50%]"
    },
    {
      name:'Kenora Golf Club',
      walking: 7,
      driving: 1,
      className:"top-[60%] left-[81%]"
    },
    {
      name: 'Central Park',
      walking: 4,
      driving: 1,
      className:"left-[55%] top-[14%]"
    },
    {
      name: 'Rotary Peace Park',
      walking: 4,
      driving: 1,
      className:"left-[14.5%] lg:left-[15.5%] top-[31%]"
    },
    {
      name: 'Moncrief Construction Sports Centre',
      walking: 4,
      driving: 1,
      className:"left-[24%] lg:left-[25%] top-[41.5%]"
    },
    {
      name: 'Kenora Skatepark',
      walking: 4,
      driving: 1,
      className:"left-[21%] lg:left-[22%] top-[39%]"
    },
]
const gasDirectory = [
  {
    name: `Petro Canada Charging Station`,
    walking: 1,
    driving: 1,
    className:"top-[46.75%] left-[58%] lg:left-[59%]"
  },
  {
    name: 'Canadian Tire Gas',
    walking: 5,
    driving: 1,
    className:"top-[50%] left-[71%] lg:left-[72%]"
  },
  {
    name: 'Tesla Supercharger',
    walking: 5,
    driving: 1,
    className:"top-[51.5%] left-[72%] lg:left-[73%]"
  },
  {
    name: 'Sunset Strip Husky Gas',
    walking: 4,
    driving: 1,
    className:"top-[51%] left-[87%] lg:left-[88%]"
  },
  {
    name: 'Shell',
    walking: 4,
    driving: 1,
    className:"left-[22.5%] lg:left-[23.5%] top-[22%]"
  },
  {
    name: 'Coop',
    walking: 4,
    driving: 1,
    className:"left-[14%] lg:left-[20%] top-[10.25%]"
  },
  {
    name: 'Westfair Foods Gas Bar',
    walking: 4,
    driving: 1,
    className:"left-[71%] lg:left-[72%] top-[.5%]"
  },
  {
    name: 'Ultramar Energy',
    walking: 4,
    driving: 1,
    className:"left-[78%] lg:left-[79%] top-[-1%]"
  },
]
const categories = [
  {
    name:'Dine',
    dir:restaurantDirectory,
    icon:'restaurant',
    long:'Restaurants'
  },
  {
    name:'Indulge',
    dir:indulgesDirectory,
    icon:'indulge',
    long:'Indulgences'
  },
  {
    name:'Pets',
    dir:petsDirectory,
    icon:'pet',
    long:'For Your Pet'
  },
  {
    name:'Shop',
    dir:shoppingDirectory,
    icon:'shopping',
    long:'Shopping Destinations'
  },
  {
    name:'Vehicles',
    dir:vehicleDirectory,
    icon:'car',
    long:'For Your Vehicle'
  },
  {
    name:'Fish',
    dir:fishingDirectory,
    icon:'fishing',
    long:'Fishing'
  },
  {
    name:'Coffee',
    dir:coffeeDirectory,
    icon:'coffee',
    long:'Coffee/Cafes'
  },
  {
    name:'Sights',
    dir:attractionsDirectory,
    icon:'attractions',
    long:'Attractions'
  },
  {
    name:'Rec',
    dir:recreationDirectory,
    icon:'recreation',
    long:'Parks and Recreation'
  },
  {
    name:'Fill',
    dir:gasDirectory,
    icon:'gas',
    long:'Fill or Charge'
  }
]
const directoryNames = [
  'gas',
  'recreation',
  'attractions',
  'coffee',
  'fishing',
  'car',
  'shopping',
  'pet',
  'indulge',
  'restaurant'
]

const test = gasDirectory.map((item)=>{
      const t = item.className.match((/\d+/)[0])
})
const Map = ({directory}) => {
    const [hideFilters, setFilters ] = useState(true)
    const [dir, setDir] = useState()
    const wrapperRef = useRef();
    const onWheel = (event) => {
      try { 
        event.preventDefault();
        event.stopPropagation();
      } catch (e) {
        console.log('ERROR', e);
      }
    };
    
    useEffect(()=>{
      if(directory !== 'none'){
        setDir({
          'gas':gasDirectory,
          'recreation':recreationDirectory,
          'attractions':attractionsDirectory,
          'coffee':coffeeDirectory,
          'fishing':fishingDirectory,
          'car':vehicleDirectory,
          'shopping':shoppingDirectory,
          'pet':petsDirectory,
          'indulge':indulgesDirectory,
          'restaurant':restaurantDirectory
        }[directory])
      }
    },[directory, setDir])
    return(
        <div className="flex flex-col items-center justify-center lg:flex-row relative w-full z-30">
        <div className="w-full lg:w-1/3 flex flex-col">
        <div className={`${hideFilters ? 'bottom-[-155px] lg:bottom-0 lg:top-0' : 'bottom-0'} fixed bottom-0 lg:relative bg-lightblue dark:bg-transparent dark:bg-gradient-to-t dark:from-island dark:via-black dark:to-island z-30 lg:p-5 pb-5 border-[10px] border-island dark:border-waterLight lg:rounded-[100px] flex flex-col items-center`}>
        <button onClick={()=>setFilters(!hideFilters)} className="w-full h-[25px] bg-white dark:bg-transparent dark:bg-gradient-to-t dark:from-black dark:via-island dark:to-island dark:border-t-2 dark:border-sun font-overlock flex lg:pointer-events-none lg:rounded-full lg:w-4/5">
          <span className="flex-1">{
          categories.find((category)=>(category.dir === dir))?.long
        }</span>
        <span className="w-[20px]">
          <svg className="w-full lg:hidden" viewBox="0 0 51 51">
                <path className="fill-island dark:fill-sun" d="M 5 10 L 46 10, 46 17, 5 17Z"/>
                <path className="fill-island dark:fill-sun" d="M 5 22 L 46 22, 46 29, 5 29"/>
                <path className="fill-island dark:fill-sun" d="M 5 34 L 46 34, 46 41, 5 41Z"/>
          </svg></span></button>
        <RadioGroup className="flex mt-1 flex-wrap lg:gap-1 items-center justify-center" value={dir} onChange={setDir}>
            {
              categories.map(category=>(
                <RadioGroup.Option key={category.name} className="contents" value={category.dir}>
                  {({ checked }) => (
                    <div className={`box-border w-1/5 lg:w-1/6 flex flex-col lg:flex-row justify-center items-center rounded-full md:rounded-[25px] transition duration-250 border-2 ${checked ? 'bg-sun dark:bg-waterDark elevation-5 border-island' : 'bg-white dark:bg-island border-transparent'}`}>
                      <Icon type={category.icon} className="w-[30px] lg:w-[35px] h-[35px] lg:h-[45px] lg:pr-[5px] fill-island" pathClassName={`${checked ? 'dark:fill-white' : 'dark:fill-sun'}`}/>
                      <div className={`font-overlock text-base`}>
                        {
                          !checked && category.name
                        }
                      </div>
                    </div>
                    )}
                </RadioGroup.Option>
              ))
            }
            </RadioGroup>
        </div>
        <div className="relative flex flex-1 flex-col lg:py-10 px-5 lg:px-10">
          <div className="absolute inset-0 bottom-[-100px] bg-sun dark:bg-island rotate-[3deg] border-[5px] border-waterDark"></div>
          <div className="flex text-island font-bold dark:text-sun text-3xl relative mb-3">
          </div>
          <div className="flex flex-col h-[300px] overflow-scroll">
          {dir && dir.map((item, index) => (
            <div
              key={item.name}
              className="flex text-island text-center font-bold dark:text-sun text-base md:text-lg relative"
            >
              <div className="w-[15px] md:w-[20px] mr-1 md:mr-10">{index + 1}</div>
              <div className="flex-1 text-start">{item.name}</div>
            </div>
          ))}
          </div>
        </div>
        </div>
        <div className='map-component w-11/12 mt-0 md:w-2/3 lg:w-1/3  lg:mt-20 order-first lg:order-last elevation-20 bg-waterLight dark:bg-island relative'>
        <TransformWrapper maxScale={4} ref={wrapperRef} initialScale={2} initialPositionX={-300} initialPositionY={-100} wheel={{ step: 0.2 }} onWheel={onWheel}>
        <TransformComponent>
        <div className="aspect-[1211/1253] relative w-full md:w-2/3 lg:w-1/3 m-1 z-20 bg-transparent">
        <Image
          src="https://sunset-inn-dev.s3.ca-central-1.amazonaws.com/map/sunset-inn-map-alt.webp"
          alt="map showing sunset inn and surrounding amenities"
          fill
          style={{ objectFit: 'cover' }}
        />
<svg className="absolute inset-0 translate-x-[-1px] translate-y-[3px] md:translate-y-0 md:translate-x-0" viewBox="0 0 1211 1253"><path d="M823 445.4a89 89 0 0 1 60 17.5 89 89 0 0 1-5 144.7 88.4 88.4 0 0 1-93 2A89.4 89.4 0 0 1 753.4 490a91.1 91.1 0 0 1 22.6-26.3c15.3-12 28.3-15.6 47-18.3ZM112.4 6.1l-.9 27.4L120 57l-10 33.5s-11.5 26-12 26-9 27-9 27L65 194l-26 48S5 312 5 311.5A799 799 0 0 1 140.5 371c71 39 122.5 178.5 42.5 262S95.5 834 95.5 837c.5 13.5 29.3 59 77.5 70a24.2 24.2 0 0 1 12.8 9.3c18.9 26-23.3 56.5-12 62.7 7.4 4.5 8.7 6.8 13.4 2.8 32.3-24 54.1 1.9 64.3 14.7 65.5 78.5 4.6 101.7-12.5 84.2-41-42.2-85.8 35.1-91.1 48.8-15.7 50.7 15.8 96 17.3 98.3l1019.7.1V6.2L112.4 6Z" className="fill-island opacity-0 dark:opacity-80"/><path d="M601.4 1176c1 0 1.9-.3 2.5-.7.7-.5 1-1.2 1-2.1 0-.9-.3-1.5-1-1.8a5 5 0 0 0-2.4-.6 7 7 0 0 0-1.2.1l.2 5h1Zm-1.1 2.8-.2 5.7c.9.5 1.8.7 2.6.7s1.5-.2 2-.8c.6-.5.9-1.3.9-2.3 0-1-.3-1.8-1-2.4-.5-.7-1.4-1-2.6-1l-1.7.1Zm-5 7.6a77.5 77.5 0 0 0 .1-18.2 39.8 39.8 0 0 1 8.8-.1c1 .1 1.9.4 2.7.8.8.4 1.5.9 2 1.6.4.7.7 1.5.7 2.5 0 2-1.1 3.5-3.2 4.1a6 6 0 0 1 3 2c.6.8 1 1.8 1 3.2 0 1.3-.5 2.5-1.2 3.4-.8 1-1.8 1.6-3 2-1 .4-2.4.6-3.8.6-2.8 0-5.1-.6-7-1.9Zm27.9-15.2.1 4.6h2.4c1.3 0 2.5 0 3.5-.2.2.3.2.7.2 1.3 0 .7-.1 1.2-.5 1.5-.3.3-1 .4-1.8.4h-3.8c0 3.4.1 5.5.3 6.1l2.1.1c3.3 0 5.4-.2 6.3-.7.2.6.4 1.3.4 2 0 .8-.3 1.2-.8 1.4-.6.3-1.6.4-3.2.4l-8.3-.1c-.6 0-1-.2-1.2-.4-.2-.3-.3-.7-.3-1.3a100.7 100.7 0 0 1 0-5v-6a53 53 0 0 0-.3-7c2.6-.2 5.2-.3 7.9-.3 2.9 0 4.7.2 5.6.5.4.1.6.5.6 1.2 0 .8-.2 1.5-.4 2a25.2 25.2 0 0 0-8.8-.5Zm27 8.2a227.7 227.7 0 0 1-2-7.3c-1.2 4.3-2 6.7-2 7.3a57.8 57.8 0 0 0 4 0Zm-2.2 3-2.7-.1a95.9 95.9 0 0 0-2.4 6.3 55.2 55.2 0 0 1-2.7-.6c-.4-.2-.7-.3-.8-.6-.2-.2-.3-.5-.3-.9s.4-1.4 1-3a475 475 0 0 0 2.8-6.8c1.2-2.8 2.2-5.6 3-8.4l2.3-.2c1.7 0 2.7.7 3.2 2.2a214.3 214.3 0 0 0 6.4 17 5 5 0 0 1-2.8 1c-1.2 0-2-.4-2.3-1.1l-.9-2.3-1-2.6H648Zm30.8.3c1.5.7 2.2 1.5 2.2 2.5 0 .5-.2 1-.7 1.5a5 5 0 0 1-1.8 1 13.7 13.7 0 0 1-7.6 0c-1.2-.3-2.4-.8-3.4-1.6-1-.7-2-1.8-2.6-3.2-.6-1.4-1-3-1-4.9 0-3.2 1-5.7 2.9-7.5 1.9-1.8 4.5-2.7 7.8-2.7 1.7 0 3.1.3 4.3 1 1.2.6 1.8 1.4 1.8 2.3a2 2 0 0 1-.8 1.7c-.6.4-1.4.7-2.4.8a4 4 0 0 0-1.6-2c-.7-.5-1.5-.8-2.3-.8a4 4 0 0 0-3.5 2 8 8 0 0 0-1.3 4.6c0 2.3.5 4.1 1.4 5.6.9 1.5 2.2 2.3 3.8 2.3 1 0 1.8-.2 2.7-.7a5 5 0 0 0 2-2Zm22.5-7v-.6c0-2.2 0-4.5-.2-6.8.7-.2 1.5-.3 2.4-.3.7 0 1.4.2 1.9.4.5.3.8.7.8 1.2l-.1 2.5-.1 3.8v6c0 2.3.2 4.2.7 5.8a7.8 7.8 0 0 1-3.7.3l-.9-.3c-.3-.1-.5-.4-.6-.8l-.2-1.4a207.9 207.9 0 0 1 0-4.4v-2.5a73.5 73.5 0 0 1-7.1 0v3.3c0 2.3.2 4.2.7 5.8a7.9 7.9 0 0 1-3.7.3c-.3 0-.6-.1-.8-.3-.3-.1-.5-.4-.7-.8l-.2-1.4a133 133 0 0 1 0-4.4v-6c0-2.2 0-4.5-.2-6.8.8-.2 1.5-.3 2.4-.3.7 0 1.4.2 1.9.4.5.3.8.7.8 1.2l-.1 2.4-.1 3.7a77.4 77.4 0 0 0 7.1 0ZM206.7 543.4c.4.5 1 .8 1.5.8l.9-.1c.2.5.2 1 .2 1.3 0 .7-.3 1.2-1 1.5-.6.3-1.3.4-2.2.4-1 0-2-.3-2.6-1a21.7 21.7 0 0 1-3.9-7.5c-.4-.1-.5-.4-.5-.8s0-.9.3-1.4h.8c.8 0 1.5-.3 2-1 .4-.6.7-1.6.7-2.7s-.3-1.9-1-2.4c-.5-.4-1.4-.6-2.6-.6h-1.1V541c0 2.3.3 4.2.8 5.7a8 8 0 0 1-2.8.4c-1 0-1.7-.2-2-.6-.4-.5-.6-1.1-.6-2v-10.4c0-2.7 0-5-.3-7l5.1-.3c6.2 0 9.3 2.1 9.3 6.3 0 2.7-1.2 4.5-3.6 5.5 1 2.4 1.8 4 2.6 4.8Zm14.5-13.2.1 4.6h2.4c1.3 0 2.5 0 3.5-.2.2.3.2.7.2 1.3 0 .7-.2 1.2-.5 1.5-.3.3-1 .4-1.8.4h-3.8c0 3.4.1 5.5.3 6.1l2.1.1c3.3 0 5.4-.2 6.3-.7.2.6.4 1.3.4 2 0 .8-.3 1.2-.8 1.4-.6.3-1.6.4-3.2.4l-8.3-.1c-.6 0-1-.2-1.2-.4-.2-.3-.3-.7-.3-1.3a100.7 100.7 0 0 1 0-5v-6a53 53 0 0 0-.3-7c2.6-.2 5.2-.3 7.9-.3 2.9 0 4.7.2 5.6.5.4.1.6.5.6 1.2 0 .8-.2 1.5-.4 2a25.2 25.2 0 0 0-8.8-.5Zm31.6 11.5c1.5.7 2.2 1.5 2.2 2.5 0 .5-.2 1-.7 1.5a5 5 0 0 1-1.8 1 13.7 13.7 0 0 1-7.6 0c-1.2-.3-2.3-.8-3.4-1.6-1-.7-2-1.8-2.6-3.2-.6-1.4-1-3-1-4.9 0-3.2 1-5.7 2.9-7.5 1.9-1.8 4.5-2.7 7.8-2.7 1.7 0 3.2.3 4.3 1 1.2.6 1.8 1.4 1.8 2.3a2 2 0 0 1-.8 1.7c-.6.4-1.4.7-2.3.8a4 4 0 0 0-1.7-2c-.7-.5-1.5-.8-2.3-.8a4 4 0 0 0-3.5 2 8 8 0 0 0-1.3 4.6c0 2.3.5 4.1 1.4 5.6.9 1.5 2.2 2.3 3.8 2.3 1 0 1.8-.2 2.7-.7a5 5 0 0 0 2-2Zm23.9 1.7c.4.5 1 .8 1.5.8l.9-.1.2 1.3c0 .7-.3 1.2-1 1.5-.6.3-1.3.4-2.2.4-1 0-2-.3-2.6-1a21.7 21.7 0 0 1-3.9-7.5c-.4-.1-.6-.4-.6-.8s.2-.9.4-1.4h.8c.8 0 1.5-.3 2-1 .4-.6.7-1.6.7-2.7s-.3-1.9-1-2.4c-.5-.4-1.4-.6-2.6-.6h-1.1V541c0 2.3.3 4.2.8 5.7a8 8 0 0 1-2.8.4c-1 0-1.7-.2-2-.6-.4-.5-.6-1.1-.6-2v-10.4c0-2.7 0-5-.3-7l5.1-.3c6.2 0 9.3 2.1 9.3 6.3 0 2.7-1.2 4.5-3.6 5.5 1 2.4 1.8 4 2.6 4.8Zm14.5-13.2.1 4.6h2.4c1.3 0 2.5 0 3.5-.2.2.3.2.7.2 1.3 0 .7-.1 1.2-.5 1.5-.3.3-1 .4-1.8.4h-3.8c0 3.4.1 5.5.3 6.1l2.1.1c3.3 0 5.4-.2 6.3-.7.2.6.4 1.3.4 2 0 .8-.3 1.2-.8 1.4-.6.3-1.6.4-3.2.4l-8.3-.1c-.6 0-1-.2-1.2-.4-.2-.3-.3-.7-.3-1.3a100.7 100.7 0 0 1 0-5v-6a53 53 0 0 0-.3-7c2.6-.2 5.2-.3 7.9-.3 2.9 0 4.7.2 5.6.5.4.1.6.5.6 1.2 0 .8-.2 1.5-.4 2a25.2 25.2 0 0 0-8.8-.5Zm27 8.2a227.7 227.7 0 0 1-2-7.3c-1.2 4.3-2 6.7-2 7.3a57.8 57.8 0 0 0 4 0Zm-2.2 3-2.7-.1a95.9 95.9 0 0 0-2.4 6.3 55.2 55.2 0 0 1-2.7-.6l-.8-.6c-.2-.2-.3-.5-.3-.9s.4-1.4 1-3a475 475 0 0 0 2.8-6.8c1.2-2.8 2.2-5.6 3-8.4l2.3-.2c1.7 0 2.7.7 3.2 2.2a214.3 214.3 0 0 0 6.4 17 5 5 0 0 1-2.8 1c-1.2 0-2-.4-2.3-1.1l-.9-2.3-1-2.6H316Zm19.9-1V535l-.1-4.8-5.6.2-.2-1.5c0-.3 0-.6.2-.9l.7-.5.9-.2h7.6c3.3 0 5.6 0 6.8-.2l.1 1.4c0 1.2-.7 1.7-2.2 1.7h-3.4a96 96 0 0 0-.2 5.6v5.6c0 2 .2 3.8.7 5.4-.9.3-1.8.4-2.9.4-1 0-1.6-.2-2-.6-.3-.5-.5-1.1-.5-2v-4.1Zm17.7-.3v-6l-.3-6.8c.8-.2 1.5-.3 2.4-.3.7 0 1.4.1 1.9.4.5.3.8.7.8 1.3l-.1 2.4-.1 3.8v6c0 2.3.2 4.2.7 5.8a7.9 7.9 0 0 1-3.7.3c-.3 0-.6-.1-.8-.3-.3-.1-.5-.4-.7-.8l-.2-1.4a133 133 0 0 1 0-4.4Zm23.3 7.2c-3 0-5.4-1-7.2-2.8a10.3 10.3 0 0 1-2.8-7.4c0-3.2 1-5.7 2.7-7.5a9.6 9.6 0 0 1 7.3-2.8c3 0 5.5 1 7.3 2.8 1.8 1.8 2.7 4.3 2.7 7.5 0 3-1 5.5-2.7 7.4a9.7 9.7 0 0 1-7.3 2.8Zm5-9.7c0-1.3-.1-2.5-.4-3.6-.3-1.2-.9-2.1-1.7-3a4 4 0 0 0-2.9-1.2c-1.5 0-2.8.6-3.7 1.8a7.1 7.1 0 0 0-1.4 4.5c0 1.4.2 2.7.5 3.9.3 1.2.8 2.2 1.6 3 .8.9 1.8 1.3 3 1.3 1.6 0 2.8-.6 3.7-1.9a8 8 0 0 0 1.3-4.8Zm30.3 9.3-1.8.2c-1.7 0-2.9-.5-3.5-1.4a236 236 0 0 0-6.8-11.6v6.8c0 2.6.3 4.5.7 5.8-.6.3-1.4.4-2.3.4-1 0-1.7-.1-2.1-.4-.4-.3-.6-.9-.6-1.7a97.5 97.5 0 0 1 0-5v-6c0-3.2-.1-5.4-.5-6.6a9 9 0 0 1 2.6-.4c1.4 0 2.5.4 3.2 1.3 1.5 1.8 3.7 5.3 6.6 10.5V534c0-2.8 0-5-.2-6.9l1.8-.2c2 0 3 .6 3 1.8l-.2 2.5v8.7l.1 6.9Zm35.6-5.2c1.5.7 2.2 1.5 2.2 2.5 0 .5-.2 1-.7 1.5a5 5 0 0 1-1.8 1 13.7 13.7 0 0 1-7.6 0c-1.2-.3-2.3-.8-3.4-1.6-1-.7-2-1.8-2.6-3.2-.6-1.4-1-3-1-4.9 0-3.2 1-5.7 2.9-7.5 1.9-1.8 4.5-2.7 7.8-2.7 1.7 0 3.1.3 4.3 1 1.2.6 1.8 1.4 1.8 2.3a2 2 0 0 1-.8 1.7c-.6.4-1.4.7-2.3.8a4 4 0 0 0-1.7-2c-.7-.5-1.5-.8-2.3-.8a4 4 0 0 0-3.5 2 8 8 0 0 0-1.3 4.6c0 2.3.5 4.1 1.4 5.6.9 1.5 2.2 2.3 3.8 2.3 1 0 1.8-.2 2.7-.7a5 5 0 0 0 2-2Zm15.4-11.5.1 4.6h2.4c1.3 0 2.5 0 3.5-.2.2.3.2.7.2 1.3 0 .7-.1 1.2-.5 1.5-.3.3-1 .4-1.8.4h-3.8c0 3.4.1 5.5.3 6.1l2.1.1c3.3 0 5.4-.2 6.3-.7.2.6.4 1.3.4 2 0 .8-.3 1.2-.8 1.4-.6.3-1.6.4-3.2.4l-8.3-.1c-.6 0-1-.2-1.2-.4-.2-.3-.3-.7-.3-1.3a100.7 100.7 0 0 1 0-5v-6a53 53 0 0 0-.3-7c2.6-.2 5.2-.3 7.9-.3 2.9 0 4.7.2 5.6.5.4.1.6.5.6 1.2 0 .8-.2 1.5-.4 2a25.2 25.2 0 0 0-8.8-.5Zm34 16.7-1.8.2c-1.7 0-2.9-.5-3.5-1.4a236 236 0 0 0-6.8-11.6v6.8c0 2.6.3 4.5.7 5.8-.6.3-1.4.4-2.3.4-1 0-1.7-.1-2.1-.4-.4-.3-.6-.9-.6-1.7a97.5 97.5 0 0 1 0-5v-6c0-3.2-.1-5.4-.5-6.6a9 9 0 0 1 2.6-.4c1.4 0 2.5.4 3.2 1.3 1.5 1.8 3.7 5.3 6.6 10.5V534c0-2.8 0-5-.2-6.9l1.8-.2c2 0 3 .6 3 1.8l-.2 2.5v8.7l.1 6.9Zm13.7-6.4v-5.6l-.1-4.8-5.6.2-.2-1.5c0-.3 0-.6.2-.9l.7-.5.9-.2h7.6c3.3 0 5.6 0 6.8-.2l.1 1.4c0 1.2-.7 1.7-2.2 1.7h-3.4a96 96 0 0 0-.2 5.6v5.6c0 2 .2 3.8.7 5.4-.9.3-1.8.4-2.9.4-1 0-1.6-.2-2-.6-.3-.5-.5-1.1-.5-2v-4.1Zm22.3-10.3.1 4.6h2.4c1.3 0 2.5 0 3.5-.2.2.3.2.7.2 1.3 0 .7-.1 1.2-.5 1.5-.3.3-1 .4-1.8.4h-3.8c0 3.4.1 5.5.3 6.1l2.1.1c3.3 0 5.4-.2 6.3-.7.2.6.4 1.3.4 2 0 .8-.3 1.2-.8 1.4-.6.3-1.6.4-3.2.4l-8.3-.1c-.6 0-1-.2-1.2-.4-.2-.3-.3-.7-.3-1.3a100.7 100.7 0 0 1 0-5v-6a53 53 0 0 0-.3-7c2.6-.2 5.2-.3 7.9-.3 2.9 0 4.7.2 5.6.5.4.1.6.5.6 1.2 0 .8-.2 1.5-.4 2a25.2 25.2 0 0 0-8.8-.5Zm30.5 13.2c.4.5 1 .8 1.5.8l.9-.1.2 1.3c0 .7-.3 1.2-1 1.5-.6.3-1.3.4-2.2.4-1 0-2-.3-2.6-1a21.7 21.7 0 0 1-3.9-7.5c-.4-.1-.6-.4-.6-.8s.2-.9.4-1.4h.8c.8 0 1.5-.3 2-1 .4-.6.7-1.6.7-2.7s-.3-1.9-1-2.4c-.5-.4-1.4-.6-2.6-.6h-1.1V541c0 2.3.3 4.2.8 5.7a8 8 0 0 1-2.8.4c-1 0-1.7-.2-2-.6-.4-.5-.6-1.1-.6-2v-10.4c0-2.7 0-5-.3-7 1.7-.2 3.4-.3 5.2-.3 6.1 0 9.2 2.1 9.2 6.3 0 2.7-1.2 4.5-3.6 5.5 1 2.4 1.8 4 2.6 4.8Zm118.6 223a92.3 92.3 0 0 0 0-18.2 31.5 31.5 0 0 1 10 .1c1.4.4 2.7.9 3.8 1.7 1.2.7 2.1 1.8 2.7 3.1.7 1.4 1 3 1 5 0 3-.9 5.4-2.7 7.3-1.8 2-4.4 2.9-7.7 2.9-3 0-5.4-.6-7.1-1.9Zm5-15.5v4.2c0 3.9 0 7-.3 9.3a7 7 0 0 0 3 .9 4 4 0 0 0 3.6-2 8.5 8.5 0 0 0 1.3-4.7c0-2.6-.5-4.5-1.6-5.8-1-1.3-2.6-2-4.6-2l-1.4.1Zm30.6 17.4c-3 0-5.4-1-7.2-2.8a10.3 10.3 0 0 1-2.8-7.4c0-3.2 1-5.7 2.7-7.5a9.6 9.6 0 0 1 7.3-2.8c3 0 5.5 1 7.3 2.8 1.8 1.8 2.7 4.3 2.7 7.5 0 3-1 5.5-2.7 7.4a9.7 9.7 0 0 1-7.3 2.8Zm5-9.7c0-1.3-.1-2.5-.4-3.6-.3-1.2-.9-2.1-1.7-3a4 4 0 0 0-2.9-1.2c-1.5 0-2.8.6-3.7 1.8a7.1 7.1 0 0 0-1.4 4.5c0 1.4.2 2.7.5 3.9.3 1.2.8 2.2 1.6 3 .8.9 1.8 1.3 3 1.3 1.6 0 2.8-.6 3.7-1.9a8 8 0 0 0 1.4-4.8Zm30.3 6.6c0 .9-.7 1.6-1.9 2.2-1.3.6-2.9.9-4.8.9-3.2 0-5.8-1-7.7-2.7a10 10 0 0 1-2.8-7.6c0-3.2.9-5.7 2.8-7.5 1.9-1.8 4.5-2.7 7.8-2.7 1.7 0 3.1.3 4.3 1 1.2.6 1.8 1.4 1.8 2.3a2 2 0 0 1-.8 1.7c-.6.4-1.4.7-2.4.8a4 4 0 0 0-1.6-2c-.7-.5-1.5-.8-2.3-.8-1.4 0-2.5.7-3.4 1.9a7.8 7.8 0 0 0-1.4 4.7c0 2.3.5 4.1 1.4 5.6.9 1.5 2.2 2.3 3.8 2.3 1.3 0 2.3-.4 2.8-1.2l-.2-5 2-.2c1.8 0 2.8.6 2.8 1.7a130.4 130.4 0 0 1-.2 4.6Zm27-7c.8 0 1.5-.3 2-1 .4-.6.7-1.5.7-2.7 0-1.4-.4-2.3-1-2.9-.5-.5-1.5-.8-2.7-.8-.3 0-.6 0-1 .2l.1 4.8v2c.7.3 1.3.5 1.8.5Zm-6.5 2.9v-6c0-2.8-.1-5.1-.4-7 1.7-.2 3.4-.3 5.2-.3 6.1 0 9.3 2.2 9.3 6.5 0 2.1-.7 3.8-2 5a6.2 6.2 0 0 1-4.4 2c-1 0-2.1-.4-3-1v2c0 2 .2 3.9.6 5.4-.6.3-1.5.4-2.8.4-1 0-1.7-.2-2-.7-.4-.4-.5-1-.5-1.9v-4.4Zm30.4-1.7a227.7 227.7 0 0 1-1.9-7.3c-1.2 4.3-2 6.7-2 7.3a57.8 57.8 0 0 0 4 0Zm-2.1 3-2.7-.1a95.9 95.9 0 0 0-2.4 6.3 55.2 55.2 0 0 1-2.7-.6l-.8-.6c-.2-.2-.3-.5-.3-.9s.4-1.4 1-3a475 475 0 0 0 2.8-6.8c1.2-2.8 2.2-5.6 3-8.4l2.3-.2c1.7 0 2.7.7 3.2 2.2a214.3 214.3 0 0 0 6.4 17 5 5 0 0 1-2.8 1c-1.2 0-2-.4-2.3-1.1l-.9-2.3-1-2.6H802Zm29.7 2c.4.5 1 .8 1.5.8l.9-.1.2 1.3c0 .7-.3 1.2-1 1.5-.6.3-1.3.4-2.2.4-1 0-2-.3-2.6-1a21.7 21.7 0 0 1-3.9-7.5c-.4-.1-.6-.4-.6-.8s.2-.9.4-1.4h.8c.8 0 1.5-.3 2-1 .4-.6.7-1.6.7-2.7s-.3-1.9-1-2.4c-.5-.4-1.4-.6-2.6-.6h-1.1V762c0 2.3.3 4.2.8 5.7a8 8 0 0 1-2.8.4c-1 0-1.7-.2-2-.6-.4-.5-.6-1.1-.6-2v-10.4c0-2.7 0-5-.3-7 1.7-.2 3.4-.3 5.2-.3 6.1 0 9.2 2.1 9.2 6.3 0 2.7-1.2 4.5-3.6 5.5 1 2.4 1.8 4 2.6 4.8Zm9.9-3.3v-6l-.3-6.8c.8-.2 1.5-.3 2.4-.3.7 0 1.4.1 1.9.4.5.3.8.7.8 1.2l-.1 2.5-.1 3.8c1.6-1.2 3.2-2.5 4.8-4 1.5-1.5 2.6-2.9 3-4 1 .2 1.6.5 2 .9.3.3.4.7.4 1.1 0 1.4-2 3.5-6.2 6.6 2.3 3.5 4.1 6 5.3 7.5.6.8 1.3 1.2 1.8 1.2l.9-.1.2 1.3c0 .6-.3 1.1-.9 1.4-.5.3-1.3.5-2.1.5-1.1 0-2.2-.5-3.3-1.5-1.4-1.4-3.2-4-5.4-8l-.5.4v2.7c0 2.3.2 4.2.7 5.8a7.9 7.9 0 0 1-3.7.3c-.3 0-.6-.1-.8-.3-.3-.1-.5-.4-.7-.8l-.2-1.4a133 133 0 0 1 0-4.4Zm43.6 245.1c0 .9-.7 1.6-1.9 2.2-1.3.6-2.9.9-4.8.9-3.2 0-5.8-1-7.7-2.7a10 10 0 0 1-2.8-7.6c0-3.2.9-5.7 2.8-7.5 1.9-1.8 4.5-2.7 7.8-2.7 1.7 0 3.1.3 4.3 1 1.2.6 1.8 1.4 1.8 2.3a2 2 0 0 1-.8 1.7c-.6.4-1.4.7-2.4.8a4 4 0 0 0-1.6-2c-.7-.5-1.5-.8-2.3-.8-1.4 0-2.5.7-3.4 1.9a7.8 7.8 0 0 0-1.4 4.7c0 2.3.5 4.1 1.4 5.6.9 1.5 2.2 2.3 3.8 2.3 1.3 0 2.3-.4 2.8-1.2l-.2-5 2-.2c1.8 0 2.8.6 2.8 1.7a130.4 130.4 0 0 1-.2 4.6Zm17.7 3.1c-3 0-5.4-1-7.2-2.8a10.3 10.3 0 0 1-2.8-7.4c0-3.2 1-5.7 2.7-7.5a9.6 9.6 0 0 1 7.3-2.8c3 0 5.5 1 7.3 2.8 1.8 1.8 2.7 4.3 2.7 7.5 0 3-1 5.5-2.7 7.4a9.7 9.7 0 0 1-7.3 2.8Zm5-9.7c0-1.3-.1-2.5-.4-3.6-.3-1.2-.9-2.1-1.7-3a4 4 0 0 0-2.9-1.2c-1.5 0-2.8.6-3.7 1.8a7.1 7.1 0 0 0-1.4 4.5c0 1.4.2 2.7.5 3.9.3 1.2.8 2.2 1.6 3 .8.9 1.8 1.3 3 1.3 1.6 0 2.8-.6 3.7-1.9a8 8 0 0 0 1.4-4.8Zm13.7 2.7V996l-.3-6.8c.8-.2 1.5-.3 2.4-.3.7 0 1.4.1 1.9.4.5.3.8.7.8 1.2l-.1 2.4-.1 3.8v5.9c0 1.5 0 2.6.2 3.2l2.2.1c3.2 0 5.3-.2 6.3-.7.2.6.3 1.3.3 2 0 .8-.2 1.2-.8 1.4-.5.3-1.5.4-3.1.4l-8.3-.1c-.6 0-1-.2-1.2-.4-.2-.3-.3-.7-.3-1.3a159.4 159.4 0 0 1 0-5Zm25.6-10.1.1 4.9h2.4c1.3 0 2.5 0 3.5-.2.2.3.2.7.2 1.3 0 .7-.1 1.2-.5 1.5-.3.3-1 .5-1.8.5h-3.8v2.7c0 2.3.3 4.3.8 5.8a8.3 8.3 0 0 1-2.5.4c-1.2 0-2-.2-2.4-.6-.4-.4-.5-1.2-.5-2.3v-9.9c0-2.7-.1-5-.4-7 2.6-.2 5.2-.3 7.9-.3 2.9 0 4.7.2 5.6.5.4.1.6.5.6 1.2 0 .8-.2 1.5-.4 2a25.2 25.2 0 0 0-8.8-.5ZM417.8 145.9v7c0 2.6.2 4.5.5 5.8-1 .3-1.9.4-2.5.4-1.8 0-2.7-.8-2.7-2.3v-10.2c-1.8 5-3 9-3.6 12.2-.5.2-1.2.3-2 .3-1.6 0-2.6-.4-3-1.2l-1.7-5.5c-.8-2.7-1.4-4.7-2-6v6.5c0 2.7.3 4.7.6 6l-2 .2c-1.8 0-2.6-.6-2.6-1.7v-12.9c0-2.2-.1-4-.5-5.3l3-.3c1.8 0 3 .7 3.5 1.9a43.6 43.6 0 0 1 3.1 8.9l1.5 5.3a69.4 69.4 0 0 1 4.7-14.6c.2-.5.6-.9 1.2-1.1a13 13 0 0 1 5 0c-.4 1.1-.5 3.4-.5 6.6Zm19.3 4.5a227.7 227.7 0 0 1-1.9-7.3c-1.2 4.3-2 6.7-2 7.3a57.8 57.8 0 0 0 4 0Zm-2.1 3-2.7-.1a95.9 95.9 0 0 0-2.4 6.3 55.2 55.2 0 0 1-2.7-.6c-.4-.2-.7-.3-.8-.6-.2-.2-.3-.5-.3-.9s.4-1.4 1-3a475 475 0 0 0 2.8-6.8c1.2-2.8 2.2-5.6 3-8.4l2.3-.2c1.7 0 2.7.7 3.2 2.2a214.3 214.3 0 0 0 6.4 17 5 5 0 0 1-2.8 1c-1.2 0-2-.4-2.3-1.1l-.9-2.3-1-2.6H435Zm16.6-1.1V146l-.3-6.8c.8-.2 1.5-.3 2.4-.3.7 0 1.4.2 1.9.4.5.3.8.7.8 1.2l-.1 2.4-.1 3.8v5.9c0 1.5 0 2.6.2 3.2l2.2.1c3.2 0 5.3-.2 6.3-.7.2.6.3 1.3.3 2 0 .8-.2 1.2-.8 1.4-.5.3-1.5.4-3.1.4l-8.3-.1c-.6 0-1-.2-1.2-.4-.2-.3-.3-.7-.3-1.3a159.4 159.4 0 0 1 0-5Zm20 0V146l-.3-6.8c.8-.2 1.5-.3 2.4-.3.7 0 1.4.2 1.9.4.5.3.8.7.8 1.2l-.1 2.4-.1 3.8v5.9c0 1.5 0 2.6.2 3.2l2.2.1c3.2 0 5.3-.2 6.3-.7.2.6.3 1.3.3 2 0 .8-.2 1.2-.8 1.4-.5.3-1.5.4-3.1.4l-8.3-.1c-.6 0-1-.2-1.2-.4-.2-.3-.3-.7-.3-1.3a159.4 159.4 0 0 1 0-5ZM97.3 180.4a92.3 92.3 0 0 0 0-18.2 31.5 31.5 0 0 1 10 .1c1.4.4 2.7.9 3.8 1.6 1.2.8 2.1 1.9 2.7 3.2.7 1.4 1 3 1 5 0 3-.9 5.4-2.7 7.3-1.8 2-4.3 2.9-7.7 2.9-3 0-5.4-.6-7.1-1.9Zm5-15.5v4.2c0 3.9 0 7-.3 9.3a7 7 0 0 0 3 .9 4 4 0 0 0 3.6-2 8.5 8.5 0 0 0 1.3-4.7c0-2.6-.6-4.5-1.6-5.8-1-1.3-2.6-2-4.6-2l-1.4.1Zm30.6 17.4c-3 0-5.4-1-7.2-2.8a10.3 10.3 0 0 1-2.8-7.4c0-3.2 1-5.7 2.7-7.5a9.6 9.6 0 0 1 7.3-2.8c3 0 5.5 1 7.3 2.8 1.8 1.8 2.7 4.3 2.7 7.5 0 3-1 5.6-2.7 7.4a9.7 9.7 0 0 1-7.3 2.8Zm5-9.7c0-1.3-.1-2.5-.4-3.7-.3-1-.9-2-1.7-2.8a4 4 0 0 0-2.9-1.3c-1.5 0-2.8.6-3.7 1.8a7.1 7.1 0 0 0-1.4 4.5c0 1.4.2 2.7.5 3.9.3 1.2.8 2.2 1.6 3 .8.8 1.8 1.3 3 1.3 1.6 0 2.8-.7 3.7-1.9a8 8 0 0 0 1.3-4.8Zm24.6-10.5 2.3-.3c1.8 0 2.8.6 2.8 1.9l-.3 2.3c1.3 2.1 2.4 6.3 3.5 12.6a36.6 36.6 0 0 0 3.8-16.5l2.3-.3c1.9 0 2.8.6 2.8 1.9 0 1.9-.6 4.6-1.9 8.1a35 35 0 0 1-3.8 8.1c-1 1.5-2.3 2.2-3.8 2.2-.8 0-1.5 0-2.1-.2-.8-4-1.6-7.5-2.4-10.2a35.1 35.1 0 0 1-3.8 8.2c-1 1.5-2.3 2.2-3.8 2.2-.9 0-1.6 0-2.2-.2-.6-3.2-1.5-6.6-2.7-10.3a32.4 32.4 0 0 0-3.6-7.9c1.2-1.1 2.4-1.7 3.4-1.7.7 0 1.3.3 1.7 1 .7 1.3 1.4 3.6 2.1 6.6.8 3 1.4 6 1.9 9a36.8 36.8 0 0 0 3.8-16.5Zm41.7 19.8-1.8.2c-1.7 0-2.9-.5-3.5-1.4a236 236 0 0 0-6.8-11.6v6.8c0 2.5.3 4.5.7 5.8-.6.3-1.4.4-2.3.4-1 0-1.7-.2-2.1-.4-.4-.3-.6-.9-.6-1.7a97.5 97.5 0 0 1 0-5v-6c0-3.2-.1-5.4-.5-6.6a9 9 0 0 1 2.6-.4c1.4 0 2.5.4 3.2 1.3 1.5 1.8 3.7 5.3 6.6 10.4v-4.6c0-2.8 0-5-.2-6.9l1.8-.2c2 0 3 .6 3 1.8l-.2 2.5v8.7l.1 6.9Zm13.7-6.5V170l-.1-4.8-5.6.2-.2-1.5c0-.3 0-.6.2-.9l.7-.5.9-.2h7.6l6.8-.1.1 1.3c0 1.2-.7 1.7-2.2 1.7h-3.4a96 96 0 0 0-.2 5.6v5.6c0 2 .2 3.8.7 5.4-.9.3-1.8.4-2.9.4-1 0-1.6-.2-2-.7-.3-.4-.5-1-.5-1.9v-4.1Zm26 6.9c-3 0-5.4-1-7.2-2.8a10.3 10.3 0 0 1-2.8-7.4c0-3.2 1-5.7 2.7-7.5a9.6 9.6 0 0 1 7.3-2.8c3 0 5.5 1 7.3 2.8 1.8 1.8 2.7 4.3 2.7 7.5 0 3-1 5.6-2.7 7.4a9.7 9.7 0 0 1-7.3 2.8Zm5-9.7c0-1.3-.1-2.5-.4-3.7-.3-1-.9-2-1.7-2.8a4 4 0 0 0-2.9-1.3c-1.5 0-2.8.6-3.7 1.8a7.1 7.1 0 0 0-1.4 4.5c0 1.4.2 2.7.5 3.9.3 1.2.8 2.2 1.6 3 .8.8 1.8 1.3 3 1.3 1.6 0 2.8-.7 3.7-1.9a8 8 0 0 0 1.3-4.8Zm24.6-10.5 2.3-.3c1.8 0 2.8.6 2.8 1.9l-.3 2.3c1.3 2.1 2.4 6.3 3.5 12.6a36.6 36.6 0 0 0 3.8-16.5l2.3-.3c1.9 0 2.8.6 2.8 1.9 0 1.9-.6 4.6-1.9 8.1a35 35 0 0 1-3.8 8.1c-1 1.5-2.3 2.2-3.8 2.2-.8 0-1.5 0-2.1-.2-.8-4-1.6-7.5-2.4-10.2a35.1 35.1 0 0 1-3.8 8.2c-1 1.5-2.3 2.2-3.8 2.2-.9 0-1.6 0-2.2-.2-.6-3.2-1.5-6.6-2.7-10.3a32.4 32.4 0 0 0-3.6-7.9c1.2-1.1 2.4-1.7 3.4-1.7.7 0 1.3.3 1.7 1 .7 1.3 1.4 3.6 2.1 6.6.8 3 1.4 6 1.9 9a36.8 36.8 0 0 0 3.8-16.5Zm41.7 19.8-1.8.2c-1.7 0-2.9-.5-3.5-1.4a236 236 0 0 0-6.8-11.6v6.8c0 2.5.3 4.5.7 5.8-.6.3-1.4.4-2.3.4-1 0-1.7-.2-2.1-.4-.4-.3-.6-.9-.6-1.7a97.5 97.5 0 0 1 0-5v-6c0-3.2-.1-5.4-.5-6.6a9 9 0 0 1 2.6-.4c1.4 0 2.5.4 3.2 1.3 1.5 1.8 3.7 5.3 6.6 10.4v-4.6c0-2.8 0-5-.2-6.9l1.8-.2c2 0 3 .6 3 1.8l-.2 2.5v8.7l.1 6.9Z" className="fill-island dark:fill-sun opacity-40 z-0"/><path d="m193 255.5-42.4 96.9L176 364s49 83 69 119-8.3 87.5-14 108.5l40.5 8.5v53l493.2-3.2c10-.6 25.3-21.1 16.3-27.8m-84.8-199-121 2s-.5-35.2-.8-40c-.4-5-11.7-10.4-20.4-10.4L389.5 376V231.5c-.1-15.5-15.3-16.2-20.9-7.5-1.2 1.8-13.2 2.8-13.4 2.5L229.6 171m215.2 1s-26.8 16.3-37.2 23.5c-10.4 7.2-29.2 21.3-24.8 23.7m596.8 444s6.4 36.8 1.2 71.5c-5.9 38.5-23.4 75.3-23.4 75.3s-7.7 9.5-51.3 37.3c-57 36.4-125 75.2-153.3 93.4-16 10.2-48.2 56.3-76 90.6-21.3 26.3-39.4 42.7-39.4 42.7M1078.5 8.5c7.5-2-38.5 9.5-46.5 14-8.1 4.6-29.8 19.3-42.5 21.8-12.8 2.5-59.5 9.2-59.5 9.2-12 1-26.3 8-26 21.8l.5 49.5c2 11.5-1.5 36.7-18.5 37.7l-189 .8 1.3 142m-1.4-72.3s-300.4 2.3-300.4 1.8c-.4.3-6.6-.9-7-3.2" className="fill-transparent stroke-[12px] lg:stroke-[8px] stroke-island"/><path d="m193 255.5-42.4 96.9L176 364s49 83 69 119-8.3 87.5-14 108.5l40.5 8.5v53l493.2-3.2c10-.6 25.3-21.1 16.3-27.8m-84.8-199-121 2s-.5-35.2-.8-40c-.4-5-11.7-10.4-20.4-10.4L389.5 376V231.5c-.1-15.5-15.3-16.2-20.9-7.5-1.2 1.8-13.2 2.8-13.4 2.5L229.6 171m215.2 1s-26.8 16.3-37.2 23.5c-10.4 7.2-29.2 21.3-24.8 23.7m596.8 444s6.4 36.8 1.2 71.5c-5.9 38.5-23.4 75.3-23.4 75.3s-7.7 9.5-51.3 37.3c-57 36.4-125 75.2-153.3 93.4-16 10.2-48.2 56.3-76 90.6-21.3 26.3-39.4 42.7-39.4 42.7M1078.5 8.5c7.5-2-38.5 9.5-46.5 14-8.1 4.6-29.8 19.3-42.5 21.8-12.8 2.5-59.5 9.2-59.5 9.2-12 1-26.3 8-26 21.8l.5 49.5c2 11.5-1.5 36.7-18.5 37.7l-189 .8 1.3 142m-1.4-72.3s-300.4 2.3-300.4 1.8c-.4.3-6.6-.9-7-3.2" className="fill-transparent stroke-[10px] lg:stroke-[6px] stroke-waterLight"/><path d="M1187.5 677c-3.3 0-159.4-10.6-161.5-10.7-13 0-45-4-63-4.6-18-.7-44.6-1.9-59.3-2-14.8-.2-29.2-2.2-44.4-4.7a195.6 195.6 0 0 1-51.5-14.6c-14-7.3-36.7-27.3-46.5-36.7-9.7-9.5-16.8-24-26.3-39.7a517.1 517.1 0 0 1-22.7-41c-10.5-20.5-9.2-21.9-12.7-38.9s-3.5-67.6-2.4-79.2c1-11.7 1.9-72 1.9-88 0-15.9 0-12.9-11.1-12.9s-110.6 2.2-125.8 2.4c-15.1.3-235 0-246.8-.8-12-.8-17.3-3.8-29.8-9.7-12.4-6-108.3-47.2-126.1-54.9-17.9-7.7-32.9-7.3-28.4-17.8a8102.3 8102.3 0 0 0 52.2-128.7c3.4-7.1 7.3-12.3 9.8-19.2 2.5-7 2.2-8.7-.5-18.4-2.6-9.8-6.8-9.5-10.2-12.7-3.3-3.3-14.6-11-18.8-13.7-4.3-2.8-8-2-11-2.1-2.9-.1-5.5-1.3-7.8-7-2.2-5.5-.6-5.7-1.7-14.1a91 91 0 0 0-1-6.2" className="fill-transparent stroke-[15px] lg:stroke-[10px] stroke-island"/><path d="M1187.5 677c-3.3 0-159.4-10.6-161.5-10.7-13 0-45-4-63-4.6-18-.7-44.6-1.9-59.3-2-14.8-.2-29.2-2.2-44.4-4.7a195.6 195.6 0 0 1-51.5-14.6c-14-7.3-36.7-27.3-46.5-36.7-9.7-9.5-16.8-24-26.3-39.7a517.1 517.1 0 0 1-22.7-41c-10.5-20.5-9.2-21.9-12.7-38.9s-3.5-67.6-2.4-79.2c1-11.7 1.9-72 1.9-88 0-15.9 0-12.9-11.1-12.9s-110.6 2.2-125.8 2.4c-15.1.3-235 0-246.8-.8-12-.8-17.3-3.8-29.8-9.7-12.4-6-108.3-47.2-126.1-54.9-17.9-7.7-32.9-7.3-28.4-17.8a8102.3 8102.3 0 0 0 52.2-128.7c3.4-7.1 7.3-12.3 9.8-19.2 2.5-7 2.2-8.7-.5-18.4-2.6-9.8-6.8-9.5-10.2-12.7-3.3-3.3-14.6-11-18.8-13.7-4.3-2.8-8-2-11-2.1-2.9-.1-5.5-1.3-7.8-7-2.2-5.5-.6-5.7-1.7-14.1a91 91 0 0 0-1-6.2" className="fill-transparent stroke-[13px] lg:stroke-[6px] stroke-sun"/></svg>
<div className="relative h-full">
        {
            dir && [...dir].map((location, key)=>(
                <Number key={location.name} 
                  className={`absolute h-[25px] w-[25px] cw lg:h-[50px] lg:w-[50px] bg-transparent p-1 flex rounded-full ${location.className}`} 
                  firstChildClassName="absolute inset-0 rounded-full z-0 opacity-80 translate-x-[-4px] lg:translate-x-[-15px] bg-gradient-to-tl from-sun via-white to-sun border-[2px] border-white"
                  imageClassName="w-[9px] block z-40" 
                  pathClassName="fill-black " 
                  num={key}/>  
            ))
        }
        </div>
        </div>
        </TransformComponent>
        </TransformWrapper>
        <div className="absolute top-0 left-0 flex w-3/4 pointer-events-none">
        </div>
        </div>
      </div>
    )
}
export default Map